import React, { useEffect } from "react";
import { graphql } from "~/graphql/codegen";
import { useMutation } from "@apollo/client/react";
import type {
  UpdateUserMetadataMutation,
  UpdateUserMetadataMutationVariables,
} from "~/graphql/codegen/graphql";
import { useUser } from "~/hooks/context-hook";

const UPDATE_USER_METADATA_MUTATION = graphql(`
  mutation UpdateUserMetadata($timezone: String) {
    updateUserMetadata(timezone: $timezone)
  }
`);

export default function ProfileInitializer({
  children,
}: React.PropsWithChildren<{}>) {
  const [updateUserMetadata] = useMutation<
    UpdateUserMetadataMutation,
    UpdateUserMetadataMutationVariables
  >(UPDATE_USER_METADATA_MUTATION);

  const user = useUser();

  useEffect(() => {
    if (user) {
      const t = Intl.DateTimeFormat().resolvedOptions().timeZone;

      updateUserMetadata({
        variables: {
          timezone: t,
        },
      });
    }
  }, [user]);

  return <>{children}</>;
}
